var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:{
  'loader--relative': _vm.isRelative,
'loader--global': _vm.isGlobal
}},[_c('i',{staticClass:"icon-portal icon-x-loading icon-portal--rotated "})])}
var staticRenderFns = []

export { render, staticRenderFns }